export const prefix = '[Create / Learning Path]';
